import styled, { keyframes } from 'styled-components';
import { Tooltip } from '../../shared/globals';

const spin = keyframes`
  from {transform: rotate(0deg);}
  to {transform: rotate(51.75deg);}
`;

const check = keyframes`
  to {
    stroke-dashoffset: 1;
  }
`;

const vibrate = keyframes`
  0% {
    transform: translate(0);
  }
  20% {
    transform: translate(-2px, 2px);
  }
  40% {
    transform: translate(-2px, -2px);
  }
  60% {
    transform: translate(2px, 2px);
  }
  80% {
    transform: translate(2px, -2px);
  }
  100% {
    transform: translate(0);
  }
`;

const magicwand = keyframes`
  from {
    transform: scale(1);
    transform-origin: center center;
    animation-timing-function: ease-out;
  }

  10% {
    transform: scale(1.05);
    animation-timing-function: ease-in;
  }

  17% {
    transform: scale(1.10);
    animation-timing-function: ease-out;
  }

  33% {
    transform: scale(1.15);
    animation-timing-function: ease-in;
  }

  45% {
    transform: scale(1);
    animation-timing-function: ease-out;
  }
`;

const warning = keyframes`
  from,
  50%,
  to {
    opacity: 1;
  }

  25%,
  75% {
    opacity: 0;
  }
`;
const reportCheck = keyframes`
  to {
    stroke-dashoffset: 0;
  }
`;

export const StyledAppSidebar = styled.div`
  ${({
    theme: {
      colors: {
        components: { railNavigation }
      }
    }
  }) => `
    position: fixed;
    background-color: var(--bg-dark);
    width: 64px;
    z-index: 10;
    height: 100%;
    top: 0;
    bottom: 0;

    @media print {
      display: none;
    }

    
    .droplist-menu {
      position: absolute;
      top: 100%;
      left: 0;
      z-index: 1080;
      min-width: 160px;
      padding: 5px 0;
      margin: 2px 0 0;
      list-style: none;
      font-size: 14px;
      text-align: left;
      background-color: #fff;
      display: none;
      user-select: none;
      border-radius: 4px;
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
      background-clip: padding-box;
      backface-visibility: hidden;
    }

    li.helpIcon {
      position: absolute;
      left: 11px;
      bottom: 50px;
      border-radius: 5px;
      color: rgba(255,255,255,.72);
      width: 40px;
      height: 40px;
      transition: .2s ease background-color;
    }
    
    li.helpIcon:hover {
      background: ${railNavigation.activeBackground};
      color: ${railNavigation.activeColor};
    }

    li.helpIcon .helplogo {
      background: #bdbdbd;
      width: 21px;
      height: 21px;
      border-radius: 20px;
      border: 1px solid #bdbdbd;
    }

    .droplist-menu.dropdown-menu--open {
      display: block;
      z-index: 1;
    }

    .brand {
      font-size: 28px;
      padding: 0 10px;
      height: 64px;
      display: flex;
      align-items: center;

      a {
        display: block;
        border-radius: 3px;
        margin-top: 12px;
        padding: 2px;
        background: 0 0;
        border: 0;
        height: 53px;
        width: 53px;
      }
    }

    img {
      width: 100%;
    }
    .sidebar {
      display: flex;
      flex-direction: column;
      height: calc(100vh - 60px);
      justify-content: space-between;
    }


    ul {
      text-align: center;
      li {
        margin: 12px auto;
        line-height: 36px;
        list-style: none;
        .nav-wrap {
          display: inline-block;
          width: 60px;
        }
        a {
          border-radius: 4px;
          width: 40px;
          line-height: 20px;
          display: flex;
          height: 40px;
          justify-content: center;
          color: rgba(255,255,255,.72);
          align-items: center;
          margin: auto;
          transition: .2s ease background-color;

          span {
            padding: 10px;
            display: inline-block;
          }
        }

        .active {
          background: ${railNavigation.activeBackground};
          color: ${railNavigation.activeColor};
        }

        a:hover {
          background: ${railNavigation.activeBackground};
          color: ${railNavigation.activeColor};
        }
      }
    }
  `}

  #icon-settings:hover {
    animation: ${spin} 0.5s linear 1;
    animation-timing-function: ease-in-out;
  }
  #icon-magicwand:hover #wand {
    animation-name: ${magicwand};
    animation-duration: 1s;
    animation-timing-function: ease-in-out;
    animation-iteration-count: 1;
    transform-origin: center center;
  }
  #shape:hover {
    animation-name: ${check};
    animation-duration: 2s;
    stroke-dashoffset: 100;
    stroke-dasharray: 100;
    animation-iteration-count: 2;
    animation-timing-function: ease-in-out;
  }
  #icon-report:hover .circle {
    animation: ${reportCheck} 3s ease-in 1;
    stroke-dashoffset: 500;
    stroke-dasharray: 500;
  }
  svg#incidents:hover .warning {
    animation: ${warning} 1s linear;
  }
  #icon-explore:hover {
    animation: ${vibrate} 0.3s linear 1;
  }
`;

export const TooltipWrapper = styled.span`
  @media (min-width: 768px) {
    top: 2px;
    ${props => (props.tipText ? Tooltip(props) : '')};
  }
`;

export const StyleDropdown = styled.div`
  .infoLogo-wrapper {
    svg {
      top: 7px;
      left: 1px;
    }
    &:before {
      font-size: 0.5rem;
      font-family: Sailec-Bold, Helvetica, sans-serif;
      background-color: #ef7c00;
      letter-spacing: 0.5px;
      border-radius: 20px;
      top: -20px;
      left: -4px;
      height: 0;
      line-height: 14px;
      position: absolute;
      content: '';
      display: inline-block;
    }
  }
  .dropdown {
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.05), 0 1px 4px rgba(0, 0, 0, 0.15);
    border: 0;
    padding: 0;
    min-width: 125px;
    bottom: 120px;
    left: 45px;
    border-radius: 2px;
    border-top: 1px #ebeef0 solid;
    text-align: left;
    position: relative;
    &:before {
      bottom: 100%;
      border: solid transparent;
      content: ' ';
      height: 0;
      width: 0;
      position: absolute;
      border-color: rgba(229, 229, 229, 0);
      border-bottom-color: #ebeef0;
      border-width: 6px;
      left: -12px;
      top: 78%;
      transform: rotate(270deg);
    }
    &.droplist-menu > a:hover {
      background-color: #f3f5f7;
    }
    a.dropdown__item {
      border-bottom: 1px #f2f2f2 solid;
      background-color: #fff;
      padding: 10px 15px;
      border-radius: 2px;
      margin: 0;
      color: #183247;
      display: block;
      line-height: 1.42857;
      white-space: nowrap;
      text-decoration: none;
      text-align: left;
      height: unset;
      width: unset;
    }
  }
`;
